module.exports = __webpack_public_path__ + "img/Working_At_Desk_W_Computer (1).87dc363.png";